export default __webpack_public_path__ + "static/media/combined-audio.8afcd2c4.mp3";